import { AppState } from '../reducers';
import { UserRole } from '../reducers/userReducer';
import { isAdmin } from '../helpers';

export const isImpersonatedSelector = (state: AppState) => Boolean(state.user.impersonation);
export const rootUrlSelector = (state: AppState) => {
  if (state.user.token && !isAdmin(state.user.roles) && state.user.roles.includes(UserRole.Sales)) {
    return '/customers';
  }
  return '/';
};
